import React, { useState, useEffect } from 'react';
import { useStyles } from './styles';
import CloseIcon from '@material-ui/icons/Close';
import AppHelper from 'helpers/AppHelper';
import { IconProgram, IconChallenge } from 'assets/images';
import { TYPE_NAME_BRIK } from 'utils';
import { Button } from "@material-ui/core";
import { arrowRight } from "assets/icons/importIcon";

interface ChooseBrikJourney {
    item?: any,
    isEdit?: boolean,
    type?: number,
    nextStep: (e: any, type: any) => void,
    backStep: (e: any, type: any) => void,
    handleCloseModal?: () => void,
    handleSetTypeName?: (type: number) => void,
}

export const ChooseBrikJourney = (props: ChooseBrikJourney) => {
    const classes = useStyles();
    const [select, setSelect] = useState(-1)


    useEffect(() => {
        if (props?.type && props?.type <= 2) {
            setSelect(props?.type)
        }
    }, [props?.type])

    const onHandleCloseModal = () => {
        if (props?.handleCloseModal) {
            props?.handleCloseModal();
        } else {
            AppHelper.hideGlobalModal();
        }
    };

    return (
        <div className={classes.bodyModalList}>
            <div className={classes.iconCloseIcon} onClick={onHandleCloseModal}>
                <CloseIcon />
            </div>

            <div className={classes.contentTitle} data-cy='cypress-program-or-private-type-modal-header'>What kind of health journey is this?</div>

            <div className={classes.listType}>
                <div
                    className={`${classes.itemType} ${select === 1 ? classes.selected : ""}`}
                    onClick={() => {
                        if (props?.handleSetTypeName) {
                            props?.handleSetTypeName(TYPE_NAME_BRIK.PROGRAM)
                        }

                        setSelect(1);
                    }}
                >
                    <img src={IconProgram} className={classes.icon} alt='' />
                    <p className={classes.typeTitle} data-cy='cypress-private-program-type'>Program</p>
                    <p className={classes.typeDes}>
                        Usually minimum of 3 months or a longer time frame.
                    </p>
                </div>

                <div
                    className={`${classes.itemType2}  ${select === 2 ? classes.selected : ""}`}
                    onClick={() => {
                        if (props?.handleSetTypeName) {
                            props?.handleSetTypeName(TYPE_NAME_BRIK.CHALLENGE)
                        }
                        setSelect(2);
                    }}
                >
                    <img src={IconChallenge} className={classes.icon} alt='' />
                    <p className={classes.typeTitle} data-cy='cypress-private-challenge-type'>Challenge</p>
                    <p className={classes.typeDes} style={{ marginBottom: 30 }}>
                        Usually tracked in days and is a shorter time frame.
                    </p>
                </div>
            </div>

            <div className={classes.footerModal}>
                <div className={classes.buttonBack}>
                    <Button variant="contained" onClick={(e: any) => props?.backStep(e, props?.type)} data-cy='cypress-program-or-challenge-back-button'>
                        Back
                    </Button>
                </div>

                <div className={classes.nextBtn}>
                    <Button variant="contained" onClick={(e: any) => props?.nextStep(e, props?.type)} disabled={select === -1} data-cy='cypress-program-or-challenge-next-button'>
                        <span>Next</span>
                        <img src={arrowRight} alt="" />
                    </Button>
                </div>

            </div>
        </div>
    );
}